import { Children } from 'react';

export const getChildrenArray = (
  children: JSX.Element[] | JSX.Element | undefined
) => {
  if (!children) return [];

  return Array.isArray(children) ? Children.toArray(children) : [children];
};
